import { AGENT_HUB_ADMIN_BASE_PATH } from '@lumapps/agent-hub/constants';
import { AppId, createPageRoute, Route } from '@lumapps/router';

// Route accessed from the side navigation (no go back button)
const agentHubComplianceAdminRoute: Route = createPageRoute({
    slug: `${AGENT_HUB_ADMIN_BASE_PATH}/guidelines-and-compliance`,
    appId: AppId.backOffice,
});

export { agentHubComplianceAdminRoute };
